import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer';

import { BlockedByFeature , notAvailablePropExceptIn } from '../../featureToggles/features/utils';
import { Features } from '../../featureToggles/features';

export interface ICounterState {
  value: number;
  upCounts: number | typeof BlockedByFeature;
}

const initialState: ICounterState = {
  value: 0,
  upCounts: notAvailablePropExceptIn({ expected: 0, availableIn: [Features.PlgExternal] })
};

const counterSlice = createSlice({
  name: 'counterExample',
  initialState,
  reducers: {
    increment(state) {
      state.value++;
      if(state.upCounts !== BlockedByFeature) {
        state.upCounts++;
      }
    },
    decrement(state) {
      state.value--;
    }
  }
});

const getCounterState = (state:RootState):ICounterState => state.counter;
const getCurrentCount = (state: RootState):number => getCounterState(state).value;
const getUpCounts = (state: RootState):number | typeof BlockedByFeature => getCounterState(state).upCounts;

export const selectors = {
  getCurrentCount,
  getUpCounts
};

export const counterReducer = counterSlice.reducer;
export const { increment, decrement } = counterSlice.actions;